import { render, staticRenderFns } from "./M2hSpotlight.vue?vue&type=template&id=2b8cdc3c&scoped=true&"
import script from "./M2hSpotlight.vue?vue&type=script&lang=js&"
export * from "./M2hSpotlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8cdc3c",
  null
  
)

export default component.exports